module.exports = {
  accent: '#fff',
  primary: '#ffd807',
  primaryDarker: '#ffc913',
  secondary: '#0082ff',
  background: '#101010',
  backgroundLighter: '#3b3b3b',
  inputBorder: '#d3d3d3',
  inputBackground: '#f4f6fc',
  inputActiveBorder: '#b3daff',
  error: '#f52c32',
  faqBrackground: '#eceef1',
};
